export default [
  {
    path: '/main/active-status-default-removed',
    meta: {
      tag: 'editactivestatusdefaultremoved',
      name: 'Editar Status Padrão de Ativos Removidos',
      breadcrumb: 'Editar Status Padrão de Ativos Removidos',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "active-status-default-removed" */ '@/views/main/settings/stock-registers/activestatusdefault/Edit.vue')
  }
]